import {JacksonType} from "@sonner/jackson-service-v2";
import {AtividadeNacional} from "../atividade.nacional";

@JacksonType("VinculoAtividadeNacionalTO")
export class VinculoAtividadeNacionalTO {

  idAtividade: string;

  atividade: string;

  @JacksonType("AtividadeNacional")
  atividadeNacional: AtividadeNacional;

  sugestao: boolean;

}
